import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Root,
  Hero,
  HeroImageContainer,
  HeroContent,
  HeroClubLogoContainer,
  StrategiesLogo,
  DescSection,
  DescTitle,
  DescSubtitle,
  Paragraph,
  CardsGrid,
} from './BusinessEducation.style';

import ClubHLogo from '../../../assets/clubh-logo.svg?react';
import logoStrategiesSrc from '../../../assets/logo-strategies@2x.png';

import inPersonEventsSrc from '../../../assets/images/education/in_person_events.jpg';
import cardImage1Src from '../../../assets/images/education/01_coaching_packages.jpg';
import cardImage2Src from '../../../assets/images/education/02_training_events.jpg';
import cardImage3Src from '../../../assets/images/education/03_free_online_lessons.jpg';

import { TwoColumnSection } from '../../../components/TwoColumnSection/TwoColumnSection';
import { EducationTypeCard } from '../../../components/EducationTypeCard/EducationTypeCard';
import { EducationBlock } from '../../../components/EducationBlock/EducationBlock';

export const BusinessEducation = () => {
  const intl = useIntl();

  return (
    <Root>
      <Hero>
        <HeroImageContainer />
        <HeroContent>
          <HeroClubLogoContainer>
            <ClubHLogo />
          </HeroClubLogoContainer>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31px"
            height="31px"
            viewBox="0 0 31 31"
            style={{ flexShrink: 0 }}
          >
            <path
              fill="#fff"
              d="m29.64 0 1.337 1.334-14.142 14.165L31 29.64l-1.334 1.336-14.165-14.141L1.36 31 .024 29.666l14.141-14.165L0 1.36 1.333.024l14.166 14.141L29.64 0Z"
            />
          </svg>
          <StrategiesLogo src={logoStrategiesSrc} alt="Strategies Logo" />
        </HeroContent>
      </Hero>

      <DescSection>
        <DescTitle>
          <FormattedMessage defaultMessage="BUSINESS EDUCATION" />
        </DescTitle>
        <DescSubtitle>
          <FormattedMessage defaultMessage="No more juggling everything alone" />
        </DescSubtitle>
        <p style={{ marginTop: '16px' }}>
          <Paragraph>
            <FormattedMessage defaultMessage="Get honest guidance, real support, and hands-on mentorship to build the business you dreamed of - one that runs smoothly, grows sustainably, and feels good to lead." />
          </Paragraph>
        </p>
      </DescSection>

      <CardsGrid>
        <EducationTypeCard
          imgSrc={cardImage1Src}
          title={intl.formatMessage({ defaultMessage: 'COACHING PACKAGES' })}
          desc={intl.formatMessage({
            defaultMessage:
              'Get honest guidance, real support, and hands-on mentorship to build the business you dreamed of - one that runs smoothly, grows sustainably, and feels good to lead.',
          })}
          ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
          ctaUrl="/education/business-education/coaching-packages"
          corner={false}
        />
        <EducationTypeCard
          imgSrc={cardImage2Src}
          title={intl.formatMessage({ defaultMessage: 'TRAINING EVENTS' })}
          desc={intl.formatMessage({
            defaultMessage:
              'If you think training has to be stuffy and one-size-fits-all, think again. Our in-person events are crafted to meet you where you are, giving you the tools and confidence to tackle your biggest goals. Ready to roadmap your toughest goals?',
          })}
          ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
          ctaUrl="/rewards?filters=(categories:!(education),tags:!(training-events))"
          corner={false}
        />
        <EducationTypeCard
          imgSrc={cardImage3Src}
          title={intl.formatMessage({ defaultMessage: 'FREE ONLINE LESSONS' })}
          desc={intl.formatMessage({
            defaultMessage:
              'Access business education and skill-building lessons anytime, anywhere. Our online library delivers practical tools and systems straight to your device.',
          })}
          ctaText={intl.formatMessage({ defaultMessage: 'GET STARTED' })}
          ctaUrl="/education/business-education/free-online-lessons"
          corner={false}
        />
      </CardsGrid>

      <TwoColumnSection
        imageSrc={inPersonEventsSrc}
        title={intl.formatMessage({
          defaultMessage:
            'For over 30 years, Strategies has helped salons and barbershops:',
        })}
        desc={
          <span>
            <TwoColumnSection.List>
              <li>
                <FormattedMessage defaultMessage="Fix cash flow and create predictable profit" />
              </li>
              <li>
                <FormattedMessage defaultMessage="Motivate teams and improve client loyalty" />
              </li>
              <li>
                <FormattedMessage defaultMessage="Build strong cultures that attract and keep staff" />
              </li>
            </TwoColumnSection.List>
            <br />
            <p>
              <FormattedMessage defaultMessage="Use your Club H points for coaching, training, or online lessons. Start building a profitable salon or barbershop you’re proud of - by design, not by chance" />
            </p>
          </span>
        }
        ctaText={intl.formatMessage({ defaultMessage: 'ABOUT STRATEGIES' })}
        ctaUrl="https://strategies.com/about-us"
        ctaTarget="_blank"
        bgColor="#f5f4f8"
        accentColor="#e74391"
      />

      <EducationBlock />
    </Root>
  );
};
